<template>
  <div :class="['axiome-logique-container', 'axiome-logique-cardinality']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <template v-if="onPropertyBlanknodes.length">
        <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false"
          :showLanguageBadge="showLanguageBadge"
          :showFirstOperand="onPropertyLiterals !== undefined && onPropertyLiterals.length > 0" />
      </template>
    </div>

    <!--Affichage Operand-->
    <span
      :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">exactly</span>

    <PropertyValue :values="cardinalityLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeCardinality",
  computed: {
    cardinalityLiterals() {
      let result = [];
      this.cardinality.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    cardinality: {
      type: Array,
      default: () => []
    },
    onProperty: {
      type: Array,
      default: () => []
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    treeDisplayForLogicalAxiom: {
      type: Boolean,
      default: false
    }
  }
}
</script>
